export default class YouTubeHelper {
    static stopAll(parentElement) {
        const iframeElements = (parentElement ?? document).querySelectorAll("iframe")

        for (var i = 0; i < iframeElements.length; i++) {
            const iframeElement = iframeElements[i];
            iframeElement.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
        }
    }
}